export default __webpack_public_path__ + "static/media/register.920212e0.mp4";